<template>
  <div style="margin: 0 auto;">
    <div id="qualityLine" :style="{width: lineWidth+'px',height: '420px'}"></div>
  </div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import * as echarts from 'echarts'
export default {
  data(){
    return{
      lineWidth: Number(window.innerWidth) - 40
    }
  },
  props:['','lineHeight','xData','yData'],
  watch:{
    yData:{
      handler(newVal) {
        if(newVal){
          this.getInit()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    h_i18n,
    getInit(){
      console.log('this.yData',this.yData)
      let myChart = echarts.init(document.getElementById('qualityLine'))
      var option = {
        grid: { x: 25, y: 20, x2: 25, y2: 20 },
        tooltip : {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function (params) {
            if(params.length==0){return}
            let base=`<div style='color:#4E5969'>`+params[0].name+'</div>'
            for(let i=0;i<params.length;i++){
                base=base+`<span style="display: inline-block;padding: 5px 5px 5px -5px;">
                    </span>`+`<span style='color:#1D2129'>`+h_i18n('38c1268c392f708ac69fd07ddf15d01f')+'</span>'+'  '+`<span style='color:#1D2129;fontWeight:bold'>`+params[i].value+`</span>`+"<br/>"
            }
            return base
          }

        },
        xAxis: {
          type: 'category',
          data: this.xData,
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#C9CDD4',//左边线的颜色
              width:'1'//坐标线的宽度
            }
          },
          axisLabel:{
            color: '#1D2129'
          },
          axisTick:{
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLabel:{
            color:"#86909C"// 设置坐标轴字的颜色
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              // 设置背景横线
              color: "#E5E6EB",
              width:'1'//坐标线的宽度
           },
          },
        },
        series: [
          {
            data: this.yData,
            type: 'line',
            smooth: true,
            symbol: 'circle',   //将小圆点改成实心 不写symbol默认空心
            symbolSize: 7,    //小圆点的大小
            areaStyle: {
              normal: {
                color: 'rgba(247, 114, 52, 0.2)' // 设置折线图下方区域的填充色
              }
            },
            itemStyle: {
              color: '#F77234', // 折线点的颜色
              borderColor: '#fff'
            },
            lineStyle:{
              color: '#F77234'
            },
          }
        ]
      };
      myChart.setOption(option);
    }
  },
  mounted(){
    this.getInit()
  }
}
</script>

<style scoped>
.dot{
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background: #165dff;
}
.legend-content{
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>